export default __webpack_public_path__ + "static/media/light.7bf0281f.svg";